import { render, staticRenderFns } from "./OrderProductionStatus.vue?vue&type=template&id=49148510&scoped=true&"
import script from "./OrderProductionStatus.vue?vue&type=script&lang=js&"
export * from "./OrderProductionStatus.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductionStatus.vue?vue&type=style&index=0&id=49148510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49148510",
  null
  
)

export default component.exports